import React from 'react';
import PieChart from '../tlelrik/pieChart';
import SmallPie from '../tlelrik/SmallPie';
import services from '../../services';
import RightTabLI from './rightTabLI';
import $ from 'jquery'
class ParcelRightTabData extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            tab: '',
            paidata: [],
            tabShowData: {},
            entity_list_object: {},
            entityListUL: null
        }
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (this.props.date !== preProp.date) {
            this.setstate();
        }
    }


    setstate = () => {
        let tabShowData = this.props.tabShowData;
        if (!tabShowData['parcel']) {
            tabShowData['parcel'] = {}
        }
        if (tabShowData['parcel'] && !tabShowData['parcel'].titdireito)
            tabShowData['parcel'].titdireito = "";
        this.setState({
            tab: this.props.tab,
            paidata: this.props.paidata,
            tabShowData: tabShowData
        });
       
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.setstate()
    }

    getEntityNumDetail = (tab, data, entnum = null) => {
        let nif = null
        console.log(data);
        if (entnum) {
            nif = entnum
            // nif = parseInt(('' + nif).trim()) / 10
            nif = parseInt(('' + nif).trim())
        }
        return (
            <ul className="list-unstyled mt-4">
                {
                    data && data.length > 0 ? data.map((_r,i)=> (
                        <RightTabLI
                            tab={tab}
                            key={i}
                            row={_r}
                            // nif={(('' + _r.entnum).trim()) / 10}
                            nif={(('' + _r.entnum).trim())}
                            paidata={this.props.paidata}
                            detailClick={(id) => this.props.detailClick(id)}
                            date={new Date()}
                        />
                    ))
                        :
                        <RightTabLI
                            tab={tab}
                            nif={nif}
                            paidata={this.props.paidata}
                            detailClick={(id) => this.props.detailClick(id)}
                            date={new Date()}
                        />
                }
            </ul>
        )
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div className="tab-content">
                {
                    (this.props.tab === "parcel") &&
                    <div className="tab-pane container active">
                        
                        {
                            Object.keys(this.state.tabShowData).length > 0 &&
                                this.state.tabShowData['parcel'] && (this.state.tabShowData['parcel'].titdireito) ?
                                <div className="searct-found mb-0">
                                    {/* <img className="img-fluid" src="imgs/logo2.png" /> */}
                                    {
                                        this.getEntityNumDetail('parcel', [], this.state.tabShowData['parcel'].titdireito)
                                    }
                                </div>
                                :
                                <div className="searct-found">
                                    <img className="img-fluid" src="imgs/search-large-icon.png" />
                                    <p className="font-14">Sem  titular</p>
                                    <h5>Associe a entidade titular do direito ao registo</h5>
                                    <p className="mt-3">
                                        <span style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color custom-btn cursor-pointer">+ Inserir</span>
                                    </p>
                                </div>
                        }
                    </div>
                }
                {
                    this.props.tab === "parcelProperty" &&
                    <div className="tab-pane container active">
                        {/* <div className="chart text-center">
                            <PieChart date={new Date()} data={this.state.paidata} />
                        </div> */}
                        {
                            this.state.tabShowData['parcelProperty'] && this.state.tabShowData['parcelProperty'].length > 0 ?
                            <>
                                <div className="chart text-center">
                                    <PieChart date={new Date()} paidatatostring={this.props.paidatatostring} data={this.state.paidata} />
                                   
                                   
                                </div>
                                {
                                    this.getEntityNumDetail('parcelProperty', this.state.tabShowData['parcelProperty'])
                                }
                                <p className="mt-3">
                                    <span style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color custom-btn cursor-pointer">+ Inserir</span>
                                </p>
                            </>
                            :
                            <div className="searct-found">
                                <img className="img-fluid" src="imgs/search-large-icon.png" />
                                <p className="font-14">Sem proprietários</p>
                                <h5>Associe pelo menos um proprietário ao registo</h5>
                                <p className="mt-3">
                                    <span style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color custom-btn cursor-pointer">+ Inserir</span>
                                </p>
                            </div>
                        }
                    </div>
                }
                {
                    (this.props.tab === "parcelExplorer") &&
                    <div className="tab-pane container active">
                        {
                            this.state.tabShowData['parcelExplorer'] && this.state.tabShowData['parcelExplorer'].length > 0 ?
                                <>
                                    <PieChart date={new Date()} paidatatostring={this.props.paidatatostring} data={this.state.paidata} />
                                    {
                                        this.getEntityNumDetail('parcelExplorer', this.state.tabShowData['parcelExplorer'])
                                    }
                                    <p className="mt-3">
                                        <span style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color custom-btn cursor-pointer">+ Inserir</span>
                                    </p>
                                </>
                                :
                                <div className="searct-found">
                                    <img className="img-fluid" src="imgs/search-large-icon.png" />
                                    <p className="font-14">Sem exploradores</p>
                                    <h5>Associe pelo menos um explorador ao registo</h5>
                                    <p className="mt-3">
                                        <span style={{borderRadius:"4px"}} data-toggle="modal" data-target='#left-popup' onClick={() => this.props.insertClickPopUp()} className="theme-color custom-btn cursor-pointer">+ Inserir</span>
                                    </p>
                                </div>
                        }
                    </div>
                }
            </div>
        )
    }
}

export default ParcelRightTabData;